import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const NotificationModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [preferences, setPreferences] = useState({
    deadlines: true,
    updates: true,
    announcements: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e?.preventDefault();
    setIsSubmitting(true);
    
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      
      setTimeout(() => {
        onClose();
        setIsSuccess(false);
        setEmail('');
        setPreferences({ deadlines: true, updates: true, announcements: false });
      }, 2000);
    }, 1500);
  };

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      <div className="relative bg-card border border-border rounded-lg shadow-elevation-5 w-full max-w-md p-6 md:p-8 animate-in fade-in zoom-in duration-250">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 rounded-lg flex items-center justify-center hover:bg-muted transition-all duration-250"
          aria-label="Close modal"
        >
          <Icon name="X" size={20} />
        </button>

        {!isSuccess ? (
          <>
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-primary/10 flex items-center justify-center mx-auto mb-4">
                <Icon name="Bell" size={32} className="text-primary" />
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground mb-2">
                Subscribe to Updates
              </h2>
              <p className="text-sm md:text-base text-muted-foreground">
                Stay informed about important conference updates and deadlines
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                type="email"
                label="Email Address"
                placeholder="your.email@example.com"
                value={email}
                onChange={(e) => setEmail(e?.target?.value)}
                required
              />

              <div className="space-y-3">
                <p className="text-sm font-medium text-foreground">Notification Preferences</p>
                
                <Checkbox
                  label="Deadline Reminders"
                  description="Get notified before important deadlines"
                  checked={preferences?.deadlines}
                  onChange={(e) => setPreferences({ ...preferences, deadlines: e?.target?.checked })}
                />
                
                <Checkbox
                  label="Conference Updates"
                  description="Receive updates about schedule changes"
                  checked={preferences?.updates}
                  onChange={(e) => setPreferences({ ...preferences, updates: e?.target?.checked })}
                />
                
                <Checkbox
                  label="General Announcements"
                  description="Stay informed about general news"
                  checked={preferences?.announcements}
                  onChange={(e) => setPreferences({ ...preferences, announcements: e?.target?.checked })}
                />
              </div>

              <div className="pt-4">
                <Button
                  type="submit"
                  variant="default"
                  size="lg"
                  fullWidth
                  loading={isSubmitting}
                  iconName="Mail"
                  iconPosition="left"
                >
                  Subscribe Now
                </Button>
              </div>

              <div className="flex items-start gap-2 pt-2">
                <Icon name="Lock" size={14} className="text-muted-foreground mt-0.5 flex-shrink-0" />
                <p className="text-xs text-muted-foreground caption">
                  Your email will be used only for conference notifications. You can unsubscribe at any time.
                </p>
              </div>
            </form>
          </>
        ) : (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-success/10 flex items-center justify-center mx-auto mb-4">
              <Icon name="CheckCircle" size={32} className="text-success" />
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground mb-2">
              Successfully Subscribed!
            </h2>
            <p className="text-sm md:text-base text-muted-foreground">
              You'll receive conference updates at {email}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationModal;